var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',_vm._g({staticClass:"cursor-pointer",class:['bf-icon', `icon-${_vm.size}`, `icon-${_vm.name}`, _vm.$attrs.class]},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }